import React, { useState, useEffect, useMemo } from 'react';
import { Collapse } from 'antd';

import './TabManage.scss';


type PeriodsTableMobileProps = {
    indexLive?: number;
    rows: any[];
  }
const { Panel } = Collapse;
const PeriodsTableMobile = ({ indexLive, rows}: PeriodsTableMobileProps) => {
    const [openPeriod, setOpenPeriod] = useState('0');
    useEffect(() => {
        if(indexLive){
            setOpenPeriod(indexLive.toString());
        }
      }, [indexLive]);
return(
    <>
        <Collapse defaultActiveKey={indexLive? [indexLive.toString()]: [openPeriod]} className="ant-collapse-icon-position-right">
            {rows.map((content, index)=>
      <Panel header={
        <div className="collapse-head">
        <h6>#{index+1}</h6>
        <h6>{content.columns[7].print ?  content.columns[7].print(content.columns[7].content):content.columns[7].content}</h6>
        {content.columns[6].print ? content.columns[6].print(content.columns[6].content):content.columns[6].content}
        </div>
    }
        key={index+1}
    >
        <table className="table-responsive-full">
        <tbody>
            <tr>
            <td data-label="Period Type">
                <span>{content.columns[0].print ? content.columns[0].print(content.columns[0].content): content.columns[0].content}</span>
            </td>
            <td data-label="Field Type">
                <span>{content.columns[1].print ? content.columns[1].print(content.columns[1].content): content.columns[1].content}</span>
            </td>
            <td data-label="Start Time">
                <span>{content.columns[2].print ? content.columns[2].print(content.columns[2].content):content.columns[2].content }</span>
            </td>
            <td data-label="End Time">
                <span>{content.columns[3].print ? content.columns[3].print(content.columns[3].content):content.columns[3].content}</span>
            </td>
            <td data-label="Elapsed">
                <span>{content.columns[4].print ? content.columns[4].print(content.columns[4].content):content.columns[4].content}</span>
            </td>
            <td data-label="Actions">
                <span>{content.columns[5].print ? content.columns[5].print(content.columns[5].content):content.columns[5].content}</span>
            </td>
            </tr>
        </tbody>
        </table>
    </Panel>
            )}
        </Collapse>
    </>

    );
  };
  export default PeriodsTableMobile;